{
  "verified": "Επαληθευμένο",
  "iv_status": {
    "verified": "Επαληθευμένο",
    "pending": "Εκκρεμεί",
    "attention": "Προσοχή"
  },
  "zoom_in": "Μεγέθυνση",
  "zoom_out": "Μεγέθυνση",
  "rotate": "Περιστροφή",
  "close": "Κλείστε το",
  "esc_to_close": "Πατήστε ESC για να κλείσετε",
  "play": "Παίξτε",
  "pause": "Παύση",
  "mute": "Σίγαση",
  "unmute": "Αποσυνδέστε τη φωνή σας από το",
  "enter_full_screen": "Είσοδος σε πλήρη οθόνη",
  "exit_full_screen": "Έξοδος πλήρους οθόνης",
  "video_not_supported": "Το πρόγραμμα περιήγησής σας δεν υποστηρίζει την ετικέτα βίντεο.",
  "skip_forward": "Μετάβαση προς τα εμπρός",
  "skip_backward": "Μετάβαση προς τα πίσω",
  "loading": "Φόρτωση",
  "loading_video": "Φόρτωση βίντεο...",
  "loading_data_description": "Παρακαλούμε περιμένετε μέχρι να φορτώσουμε τα δεδομένα σας. Αυτό δεν θα διαρκέσει πολύ.",
  "no_results": "Δεν υπάρχουν αποτελέσματα",
  "nothing_found": "Δεν βρέθηκε τίποτα",
  "save_changes": "Αποθήκευση αλλαγών",
  "saved_exclamation": "Σωθήκαμε!",
  "saving": "Εξοικονόμηση",
  "validating": "Επικύρωση",
  "error": "Σφάλμα",
  "optional": "Προαιρετικό",
  "search_property": "Αναζήτηση ακινήτου",
  "reset_search": "Επαναφορά αναζήτησης",
  "no_items_to_show": "Δεν υπάρχουν αντικείμενα προς εμφάνιση",
  "showing_range_of_total_items": "Εμφάνιση {{range}} από {{total}} στοιχεία",
  "rows_per_page": "Γραμμές ανά σελίδα",
  "page_of_pages": "Σελίδα {{page}} από {{pages}}",
  "go_to_first_page": "Μετάβαση στην πρώτη σελίδα",
  "go_to_previous_page": "Πηγαίνετε στην προηγούμενη σελίδα",
  "go_to_next_page": "Μετάβαση στην επόμενη σελίδα",
  "go_to_last_page": "Μετάβαση στην τελευταία σελίδα",
  "sort_in_asc": "Ταξινόμηση σε αύξουσα σειρά",
  "sort_in_desc": "Ταξινόμηση κατά φθίνουσα σειρά",
  "sort_a_z": "Ταξινόμηση A → Z",
  "sort_z_a": "Ταξινόμηση Z → A",
  "clear_sorting": "Σαφής διαλογή",
  "reach_us_at_email": "Επικοινωνήστε με την υποστήριξη στη διεύθυνση support@chekin.com",
  "please_wait": "Παρακαλώ περιμένετε",
  "feature_coming_soon": "Σύντομα",
  "feature_coming_soon_description": "Αυτή η λειτουργία βρίσκεται υπό ανάπτυξη και θα είναι διαθέσιμη σύντομα. Μείνετε συντονισμένοι για ενημερώσεις!",
  "download_all": "Λήψη όλων",
  "entry_forms": "Έντυπα συμμετοχής",
  "tutorial": "Σεμινάριο",
  "liveness_video": "Βίντεο ζωντάνιας",
  "beta": "Beta",
  "reviews": "Κριτικές",
  "learn_more": "Μάθετε περισσότερα",
  "this_cannot_be_reverted": "Αυτό δεν μπορεί να αντιστραφεί",
  "delete": "Διαγραφή",
  "cancel": "Ακύρωση",
  "you_have_made_changes": "Έχετε κάνει αλλαγές",
  "would_you_like_to_save_them": "Θα θέλατε να τα σώσετε;",
  "save": "Αποθήκευση",
  "dont_save": "Μην αποθηκεύετε",
  "copied_exclamation": "Αντιγραφή!",
  "search_placeholder": "Αναζήτηση...",
  "type_to_search": "Πληκτρολογήστε για αναζήτηση...",
  "loading_more": "Φόρτωση...",
  "no_options": "Δεν υπάρχουν επιλογές",
  "select_option": "Επιλέξτε επιλογή",
  "clear_all": "Εκκαθάριση όλων",
  "remove_item": "Κατάργηση του {{label}}",
  "upload_file": "Ανέβασμα αρχείου",
  "download_attachment": "Λήψη συνημμένου",
  "remove_file": "Αφαίρεση αρχείου",
  "open_calendar": "Ανοιχτό ημερολόγιο",
  "clear_dates": "Εκκαθάριση ημερομηνιών",
  "select_dates": "Επιλέξτε ημερομηνίες",
  "pick_date_range": "Επιλέξτε ένα εύρος ημερομηνιών",
  "from": "Από το",
  "to": "Προς",
  "pick_month": "Διαλέξτε ένα μήνα",
  "pick_date": "Διαλέξτε μια ημερομηνία",
  "month": "Μήνας",
  "day": "Ημέρα",
  "year": "Έτος",
  "done": "Έγινε",
  "wrong_period_of_dates": "Η επιλεγμένη περίοδος είναι άκυρη",
  "date_range_max_days_error_one": "Το εύρος δεν μπορεί να υπερβαίνει την {{count}} ημέρα",
  "date_range_max_days_error_other": "Το εύρος δεν μπορεί να υπερβαίνει τις {{count}} ημέρες",
  "date_range_min_days_error_one": "Το εύρος πρέπει να είναι τουλάχιστον {{count}} ημέρα",
  "date_range_min_days_error_other": "Το εύρος πρέπει να είναι τουλάχιστον {{count}} ημέρες",
  "past_dates": "Η ημερομηνία δεν μπορεί να είναι πριν από το {{minDate}}__",
  "future_dates": "Η ημερομηνία δεν μπορεί να είναι μετά το {{maxDate}}__",
  "signature_placeholder_text": "Υπογράψτε μέσα σε αυτό το πλαίσιο.<br/> Χρησιμοποιήστε το δάχτυλό σας.<br/> Πατήστε για να ξεκινήσετε.",
  "open_devices_camera": "Ανοίξτε την κάμερα της συσκευής",
  "place_document_inside_frame": "Τοποθετήστε το έγγραφό σας μέσα στο πλαίσιο",
  "close_other_application_that_may_be_using_your_camera": "Κλείστε άλλες εφαρμογές που μπορεί να χρησιμοποιούν την κάμερά σας",
  "if_you_use_external_camera_disconnect_and_reconnect": "Εάν χρησιμοποιείτε εξωτερική κάμερα, αποσυνδέστε και επανασυνδέστε την.",
  "close_the_browser_re_open_it": "Κλείστε το πρόγραμμα περιήγησης και ανοίξτε το ξανά",
  "camera_errors": {
    "experiencing_camera_issues": "Αντιμετωπίζετε προβλήματα με την κάμερα;",
    "chekin_cant_use_your_camera": "Ο Τσέκιν δεν μπορεί να χρησιμοποιήσει την κάμερά σας",
    "please_try_a_different_browser": "Η κάμερά σας δεν λειτουργεί σε αυτό το πρόγραμμα περιήγησης. Προσπαθήστε να ανοίξετε το σύνδεσμο σε ένα άλλο πρόγραμμα περιήγησης.",
    "permissions_denied": "Άδεια αρνηθεί",
    "camera_permissions_denied": "Η κάμερα δεν ανοίγει; Βεβαιωθείτε ότι επιτρέπετε στο πρόγραμμα περιήγησης την άδεια χρήσης της κάμερας.",
    "no_camera_device_found": "Δεν βρέθηκε συσκευή κάμερας. Παρακαλούμε συνδέστε μια κάμερα.",
    "constraints_camera_error": "Οι περιορισμοί δεν μπορούν να ικανοποιηθούν από τις διαθέσιμες συσκευές.",
    "safari_camera_error": "Η Safari δεν μπορούσε να ικανοποιήσει τις απαιτήσεις της κάμερας",
    "try_chrome_or_firefox": "Δοκιμάστε το Chrome ή το Firefox"
  },
  "clear": "Σαφής",
  "show_less": "Εμφάνιση λιγότερων",
  "show_more": "Εμφάνιση περισσότερων",
  "tap_here_to_sign": "Πατήστε εδώ για να υπογράψετε",
  "click_here_to_sign": "Κάντε κλικ εδώ για να υπογράψετε",
  "prefix": "Πρόθεμα",
  "prefix_required": "Απαιτείται πρόθεμα",
  "reset": "Επαναφορά",
  "show_password": "Εμφάνιση κωδικού πρόσβασης",
  "hide_password": "Απόκρυψη κωδικού πρόσβασης",
  "increment": "Αύξηση",
  "decrement": "Μείωση",
  "create_option": "Δημιουργήστε το \"{{input}}__\"",
  "year_out_of_range": "Το έτος πρέπει να είναι μεταξύ {{min}} και {{max}}",
  "clear_date": "Καθαρή ημερομηνία",
  "select_date": "Επιλέξτε ημερομηνία",
  "draw_signature_here": "Υπογράψτε εδώ",
  "signature_hint": "Χρησιμοποιήστε το ποντίκι ή το δάχτυλό σας",
  "clear_signature": "Καθαρή υπογραφή",
  "draw_signature_here_mobile": "Σχεδιάστε την υπογραφή σας",
  "signature_hint_mobile": "Χρησιμοποίησε το δάχτυλό σου",
  "camera_access_needed": "Απαιτείται πρόσβαση στην κάμερα",
  "camera_access_needed_text": "Επιτρέψτε την πρόσβαση στην κάμερα για να τραβήξετε τη φωτογραφία. Εάν η πρόσβαση είναι αποκλεισμένη, ενεργοποιήστε την κάμερα στις ρυθμίσεις του προγράμματος περιήγησής σας και, στη συνέχεια, δοκιμάστε ξανά.",
  "dialog": "Διάλογος"
}
